import type { CategoryContent } from '../row.js';

export const SPANISH_HISTORY: CategoryContent = {
  bscba: [
    [
      'Welk Germaans volk stichtte een koninkrijk in Iberië na de Romeinse ineenstorting?',
      [
        'De Visigoten',
        'De Ostrogoten',
        'De Franken',
        'De Vandalen',
      ],
      0,
      'De Visigoten heersten van de 5e tot vroeg 8e eeuw over Iberië, stelden een monarchie en wettelijke codes in. De Vandalen hielden kortstondig zuidelijke gebieden.',
    ],
    [
      'In welk jaar staken Moslimlegers voor het eerst vanuit Noord-Afrika naar Iberië over?',
      [
        '711 CE',
        '681 CE',
        '751 CE',
        '789 CE',
      ],
      0,
      'De Umayyadse verovering begon in 711 CE, traditioneel onder leiding van Tariq ibn Ziyad, en transformeerde het schiereiland snel.',
    ],
    [
      'Wat was de naam van het Christelijke, door Moslims belegde territorium in middeleeuws Iberië?',
      [
        'Al-Andalus',
        'Granada',
        'Castilië',
        'Aragón',
      ],
      0,
      'Al-Andalus was het Islamitische territorium dat het grootste deel van Iberië op zijn hoogtepunt omspande (8e–15e eeuwen).',
    ],
    [
      'Welk Christelijk koninkrijk initieerde de Reconquista vanuit zijn sterkte in de noordelijke bergen?',
      [
        'Asturië',
        'Navarra',
        'Catalonië',
        'Galicië',
      ],
      0,
      'Asturië, in de noordelijke bergen, wordt traditioneel gezien als het startpunt van de Christelijke herovering, vooral onder Pelayo.',
    ],
    [
      'Wat was de titel van de heerser van Al-Andalus, gelijkwaardig aan een koning?',
      [
        'Kalief of Emir',
        'Sultan',
        'Vizier',
        'Wazir',
      ],
      0,
      'Al-Andalus werd geregeerd door kalieven (later emirs na de Umayyadse ineenstorting) die Islamitische autoriteit vertegenwoordigden.',
    ],
    [
      'Welk koningskoppel verenigde Spanje door huwelijk en voltooide de Reconquista?',
      [
        'Ferdinand van Aragón en Isabella van Castilië',
        'Karel V en Isabella van Portugal',
        'Filips II en Maria van Engeland',
        'Jacobus I en Margaretha van Frankrijk',
      ],
      0,
      'De Katholieke Vorsten Ferdinand en Isabella trouwden in 1469, verenigden Aragón en Castilië, en veroverden Granada in 1492.',
    ],
    [
      'Welke grote oceaanreis sponsorde Spanje in 1492?',
      [
        'Columbus\' expeditie naar Amerika',
        'Vasco da Gama\'s reis naar Indië',
        'Magellaan\'s omzeiling van de aardbol',
        'John Cabot\'s verkenning van Noord-Amerika',
      ],
      0,
      'Columbus\' westwaartse reis, gesponsord door de Katholieke Vorsten, bereikte de Caraïben in 1492 en startte Spaanse kolonisatie van Amerika.',
    ],
    [
      'Welke regio van Spanje was het laatste Islamitische bolwerk dat tijdens de Reconquista viel?',
      [
        'Granada',
        'Sevilla',
        'Córdoba',
        'Toledo',
      ],
      0,
      'Granada viel in 1492 aan de Katholieke Vorsten, eindigend ongeveer 800 jaar Moslimheerschappij in Iberië.',
    ],
    [
      'Waar was de Spaanse Inquisitie in de late 15e eeuw primair op gericht?',
      [
        'Het afdwingen van Katholieke orthodoxie en het onderzoeken van ketterij',
        'Het onderdrukken van Islamitische opstanden',
        'Het voorkomen van Joodse immigratie',
        'Het controleren van de adel',
      ],
      0,
      'Ingesteld in 1478 door Ferdinand en Isabella, onderzocht de Spaanse Inquisitie ketterij en dwong Katholieke doctrine af, inclusief uitzetting van onbekeerde Joden en Moslims.',
    ],
    [
      'Welke Habsburgse monarch zag Spanje\'s grootste grondgebied in de 16e eeuw?',
      [
        'Karel V',
        'Filips II',
        'Ferdinand I',
        'Maximiliaan II',
      ],
      0,
      'Karel V (r. 1516–1556) erfde Spanje, de Nederlanden, Oostenrijk en delen van Italië, heersend over het grootste Europese rijk van zijn tijd.',
    ],
    [
      'Wat was het primaire doel van Spanje\'s koloniale administratie in Amerika?',
      [
        'Edelmetalen winnen en nederzettingen onder Krooncontrole stichten',
        'Inboorlingen vreedzaam zonder militair geweld bekeren',
        'Onafhankelijke handelsrepublieken stichten',
        'Landbouwcommunes stichten',
      ],
      0,
      'Spaanse kolonialisme richtte zich op het exploiteren van hulpbronnen (vooral zilver uit Potosí) en het stichten van hiërarchische nederzettingen onder directe Kroonbestuur.',
    ],
    [
      'Welke vloot werd infaam verslagen door de Engelsen in 1588?',
      [
        'De Spaanse Armada',
        'De Onoverwinbare Vloot',
        'De Atlantische Eskader',
        'De Middellandse Zeemarine',
      ],
      0,
      'Filips II\'s Armada voer uit om Engeland in 1588 aan te vallen maar werd door stormen en Engelse troepen verstrooid, een eerste grote Spaanse zeenederlaag.',
    ],
    [
      'Welk conflict bepaalde Spanje\'s opvolging na de dood van Karel II in 1700?',
      [
        'De Oorlog van de Spaanse Successie',
        'De Dertigjarige Oorlog',
        'De Oorlog om Jenkins\' Oor',
        'De Schiereilandoorlog',
      ],
      0,
      'De Oorlog van de Spaanse Successie (1701–1714) plaatste Europese mogendheden tegen elkaar om de Spaanse troon, resulterend in Burbonisch bewind in plaats van Habsburg.',
    ],
    [
      'Wie was de Spaanse generaal die de opstand tegen Napoleons bezetting aanvoerde?',
      [
        'Francisco Goya (als propagandist voor het verzet)',
        'Koning Ferdinand VII',
        'Juan Carlos I',
        'Miguel de Cervantes',
      ],
      0,
      'De Schiereilandoorlog (1808–1814) zag Spaanse guerrilla\'s en legers tegen Franse bezetting; Ferdinand VII werd het verzetsymbool hoewel in Frankrijk gevangen.',
    ],
    [
      'Wat was het gevolg van de Spaans-Amerikaanse Oorlog in 1898?',
      [
        'Spanje verloor Cuba, Puerto Rico en de Filipijnen, eindigend zijn Amerikaans imperium',
        'Spanje behield alle koloniën maar verloor zeemacht',
        'Spanje verkreeg nieuw grondgebied in Afrika',
        'Spanje en de VS verdeelden de Caraïben gelijk',
      ],
      0,
      'De oorlog van 1898 eindigde het Spaanse kolonialisme in Amerika en de Stille Oceaan, wat het definitieve instorten van het Spaanse rijk markeerde.',
    ],
  ],
  msc: [
    [
      'Wat was de primaire administratieve structuur van Visigotisch Spanje die latere koninkrijken beïnvloedde?',
      [
        'De liber iudiciorum (wettelijke code) met gecentraliseerde koninklijke justitie',
        'Een zuiver feodaal stelsel, geërfd van Rome',
        'Onafhankelijke stadsstaten zonder centrale autoriteit',
        'Democratische vergaderingen naar Grieks stadsstaten model',
      ],
      0,
      'De Visigotische liber iudiciorum schiep een geschreven juridisch kader voor koninklijk bestuur dat Christelijke Spaanse koninkrijken beïnvloedde.',
    ],
    [
      'Welke Islamitische dynastie heerste over Al-Andalus tijdens zijn grootst cultureel en economisch bloei?',
      [
        'Het Umayyadse Kalifaat (8e–10e eeuwen)',
        'Het Abbasidenkalifaat',
        'Het Fatimidenkalifaat',
        'Het Ottomaanse Rijk',
      ],
      0,
      'De Umayyadse periode, vooral het 10e-eeuwse Kalifaat van Córdoba, maakte Al-Andalus tot Europa\'s rijkste en wetenschappelijk meest geavanceerde regio.',
    ],
    [
      'Wat veroorzaakte de fragmentering van Al-Andalus in taifa\'s (kleine koninkrijken) in de 11e eeuw?',
      [
        'De ineenstorting van het Umayyadse Kalifaat en politieke fragmentering',
        'Een Christelijke militaire invasie vanuit het noorden',
        'Interne religieuze scheuren tussen Soennische en Shiitische Moslims',
        'Een massale pest die de heersende elite doodde',
      ],
      0,
      'Het Umayyadse stelsel stortte rond 1031 ineen, waardoor dozijnen onafhankelijke taifa\'s vatbaar waren voor Christelijke herovering en Berber-invasies.',
    ],
    [
      'Welke Castiliaanse heerser stelde een uniforme wettelijke code op voor zijn gebieden in de 13e eeuw?',
      [
        'Alfons X, die de Siete Partidas opstelde',
        'Ferdinand III, die Sevilla veroverde',
        'Jacobus I van Aragón',
        'Sancho III van Navarra',
      ],
      0,
      'Alfons X de Wijze (r. 1252–1284) creëerde de Siete Partidas, een uitgebreide wettelijke code waarin koninklijke autoriteit centraal stond en feodale adelprivileges werden gereduceerd.',
    ],
    [
      'Welke economische rol speelde Al-Andalus in Middellandse Zee en Europese handelsnetwerken?',
      [
        'Het diende als cruciaal intermediair voor Noord-Afrikaanse en Midden-Oosterse goederen in Christelijk Europa',
        'Het was economisch geïsoleerd en produceerde alleen landbouwproducten',
        'Het importeerde meeste vervaardigde goederen vanuit Italië',
        'Het controleerde al de Middellandse Zeepiraterij en zeevaartvak',
      ],
      0,
      'Al-Andalus functioneerde als handelshub dat de Islamitische wereld met Christelijk Europa verbond, exporterend zijde, landbouw en metaalwerk.',
    ],
    [
      'Welke militaire innovatie gebruikten de Spanjaarden uitgebreid tijdens de Reconquista?',
      [
        'Versterkte grensstedenen (presidios) die omstreden grensgebieden controleerden',
        'Vloten om vijandelijke sterke punten te omzeilen',
        'Vroeg buskruit kanonnen systematisch ingezet',
        'Zwaarmachtige ridders uitsluitend zonder infanterie-ondersteuning',
      ],
      0,
      'Spaanse koninkrijken ontwikkelden een grensversterkingsstelsel met militaire nederzettingen die nieuw veroverde grondgebieden tegen heroveringen verdedigden.',
    ],
    [
      'Wat was de basis van het encomienda-stelsel in Spaanse kolonies in Amerika?',
      [
        'Kolonisten controle geven over inheemse arbeid tegen Christelijke onderricht',
        'Rechtstreekse lonen uitbetaald aan inheemse arbeiders door de Kroon',
        'Slavernij gekocht van Afrikaanse slavenhandelaars',
        'Feodale contracten die inheemse rechten gelijk beschermden als Spaanse kolonisten',
      ],
      0,
      'De encomienda gaf kolonisten tribut- en arbeidsrechten over inheemse volkeren, gerechtvaardigd als bekerings- en "civiliserings"-verplichting maar functionerend als exploitatie.',
    ],
    [
      'Welke regio werd het centrum van Habsburgse macht in Spanje en zetel van koninklijke administratie?',
      [
        'Castilië, vanwege zijn grootte en kracht',
        'Aragón, vanwege zijn Middellandse Zeehandelsnetwerken',
        'Granada, het meest commercieel ontwikkeld',
        'Andalusië, de rijkste landbouwegio',
      ],
      0,
      'Castilië\'s grootte en hulpbronnen maakten het de dominante partner in de unie; de Kroon van Aragón werd ondergeschikt ondanks initiële gelijkheid.',
    ],
    [
      'Wat was het primaire religieuze gevolg van de Reconquista voor nieuw veroverde populaties?',
      [
        'Gedwongen bekering of uitzetting van Moslims en Joden',
        'Religieuze pluralisme gegarandeerd door Christelijke heersers',
        'Vrijwillige geleidelijke bekering over eeuwen',
        'Integratie van Islamitische praktijken in Katholieke eredienst',
      ],
      0,
      'Christenen dwongen bekering of uitzetting af: het Edict van 1492 joeg onbekeerde Joden uit; Moslims ondervonden toenemende druk culminerend in 17e-eeuwse uitzettingen.',
    ],
    [
      'Welke Amerikaanse zilvervondsten werden het economische hart van Spanje\'s 16e-eeuwse rijkdom?',
      [
        'Potosí in Bolivië',
        'Mexicaanse goudmijnen',
        'Peruviaanse smaragdvelden',
        'Caribische zoutafzettingen',
      ],
      0,
      'Potosí\'s enorme zilverproductie (wellicht 50% van al het zilver wereldwijd) stroomde naar Spanje, wat de Habsburgse oorlogen financierde maar ook inflatie veroorzaakte.',
    ],
    [
      'Welk politiek conflict karakteriseerde Kroon-adellijkeverhouding in de 16e eeuw?',
      [
        'De Kroon consolideerde macht door aristocratische fuero\'s (privileges) te onderwerpen',
        'Adel handhaafde feodale onafhankelijkheid van koninklijke autoriteit',
        'De Kroon bood adel bestuur van Amerikaanse koloniën zonder beperking',
        'Aristocraten en Kroon deelden macht gelijk via een geschreven grondwet',
      ],
      0,
      'Habsburg-monarchen, vooral Karel V en Filips II, reduceerden systematisch adelsprivileges en centraliseerden autoriteit, hoewel adellijke landgoederen behouden bleven.',
    ],
    [
      'Hoe verschilden Filips II\'s religieuze beleidslijnen van zijn voorgangers?',
      [
        'Hij intensiveerde Contrareformatie-orthodoxie en onderdrukte heterodoxe gedachten strenger',
        'Hij ontspande Inquisitie-handhaving en stond religieuze tolerantie toe',
        'Hij allieert zich met Protestantse mogendheden tegen Rome',
        'Hij stelde Spanje in als seculiere staat scheidend Kerk en Kroon',
      ],
      0,
      'Filips II maakte religieuze uniformiteit tot hoeksteen van staatsbeleid, versterkte de Inquisitie en verdreef agressief Protestantisme en crypto-Jodendom.',
    ],
    [
      'Wat was het Verdrag van Utrecht\'s primaire impact op Spaanse macht in 1713?',
      [
        'Spanje behield Spanje en Spaans-Amerika maar verloor Europese gebieden (Nederlanden, Italië)',
        'Spanje heroverde al zijn Europese grondgebieden',
        'Spanje verloor controle van Amerikaanse koloniën aan Groot-Brittannië',
        'Spanje\'s monarchie werd afgeschaft ten gunste van republiek',
      ],
      0,
      'Utrecht eindigde Spaanse dominantie in Europa: Spanje behield Amerika en thuisland maar gaf Nederlanden, Italië en Gibraltar af aan rivalen.',
    ],
    [
      'Welke Verlichting-era Spaanse heerser probeerde grote administratieve en economische hervormingen?',
      [
        'Karel III, die bureaucratie centraliseerde en Kerkbijdrage reduceerde',
        'Karel II, de laatste Habsburg',
        'Ferdinand VI, gefocust alleen op militaire expansie',
        'Filips V, die alle hervormingen afwees',
      ],
      0,
      'Karel III (r. 1759–1788) implementeerde Bourbonische hervormingen: bureaucratische centralisatie, verminderde geestelijke macht, Bourbonisch staatsbestuur.',
    ],
    [
      'Wat was de Schiereilandoorlog\'s geopolitieke betekenis voorbij militaire uitkomst?',
      [
        'Het toonde populaire nationalisme kon continentale macht weerstaan en beïnvloedde bevrijdingsbewegingen in Europa',
        'Het consolideerde Franse hegemonie permanent over Spanje',
        'Het resulteerde in onderhandelde onafhankelijkheid voor Spaans-Amerika',
        'Het stelde Spanje in als puur agraire economie onbekwaam tot industrialisatie',
      ],
      0,
      'Spaanse guerrilla-weerstand (1808–1814) inspireerde nationalistische bewegingen in Europa en Amerika, uitdagend Napoleonse suprematie.',
    ],
  ],
  phd: [
    [
      'Welk historiografisch debat omringt de oorsprongen en omvang van Visigotische "verval" voorafgaand aan de Islamitische verovering?',
      [
        'Revisionistische geleerden stellen recente archeologische bewijzen institutionele continuïteit in plaats van ineenstorting voor 711',
        'Alle geleerden zijn het erover eens dat Visigotische staat uniform zwak en intern verdeeld was',
        'Middeleeuwse bronnen documenteren nauwkeurig interne burgeroorlogen zonder overdrijving',
        'De Visigoten hadden al het Christendom in de 8e eeuw verlaten',
      ],
      0,
      'Moderne geleerdheid betwist de traditionele "verval en val"-vertellingen; enig bewijs suggereert institutionele stabiliteit, hoewel opvolgingsconflicten door indringers werden uitgebuit.',
    ],
    [
      'Hoe functioneerde de belastingstructuur van Al-Andalus onder het Umayyadse Kalifaat over religieuze gemeenschappen?',
      [
        'De jizya (belasting op niet-Moslims) financierde administratie terwijl Moslims extra zakat betaalden, creërend economische stratificatie',
        'Alle inwoners betaalden identieke belastingen ongeacht religie of status',
        'Niet-Moslims betaalden geen belastingen maar werden van handel uitgesloten',
        'Religieuze gemeenschappen collectioneerden belastingen onafhankelijk zonder centrale toezicht',
      ],
      0,
      'De jizya en zakat creëerden verschillende fiscale statussen: niet-Moslimbelastingopbrengsten ondersteunden de administratie, terwijl de Moslim-zakat welzijn financierde, wat complexe kruissubsidies opleverde.',
    ],
    [
      'Welke rol speelden de Almohadi- en Almoraviden-invasies in hervorming van Al-Andalus\' politieke economie?',
      [
        'Beide Noord-Afrikaanse bewegingen versterkten gecentraliseerde Islamitische autoriteit maar verstoorden bestaande taifa-handelsnetwerken',
        'Ze hadden minimale impact; taifa\'s bleven onafhankelijk en machtig',
        'Ze elimineerden volledig Islamitische cultuur uit Iberië',
        'Ze brachten permanente vrede en verenigde Al-Andalus permanent',
      ],
      0,
      'Almoraviden (11e e.) en Almohadi (12e e.) herstelden Islamitische orthodoxie en centraliseerden de controle, waarbij ze de geavanceerde maar gefragmenteerde taifa-economie verstoorden.',
    ],
    [
      'Hoe verschilden economische organisatie van grens-presidios van binnenlandse Castiliaanse nederzettingen?',
      [
        'Grenssteden opereerden onder militaire krijgswet met Kroongestuurde arbeidstoewijzing; binnenlandse steden behielden meer traditionele fuero-autonomie',
        'Grens- en binnenlandse steden hadden identieke bestuurstructuren',
        'Binnenlandse steden waren zuiver pastoraal; grenssteden zuiver militair',
        'Grenssteden waren autonoom; het binnenland was direct Kroongecontroleerd',
      ],
      0,
      'Grens-presidios opereerden onder strengere koninklijke militaire jurisdictie om nieuw veroverd grondgebied te beveiligen; binnenlandse steden behielden lokale fuero\'s.',
    ],
    [
      'Welke mechanismen stelden de Reconquista ongelijk vooruit over het schiereiland (bijv. Castilië sneller dan Aragón)?',
      [
        'Castilië\'s grotere bevolking, meer gecentraliseerde fiscale extractie en geografische concentratie van Islamitische grondgebieden maakten snelle opeenvolgende verovering mogelijk',
        'Aragón vermeed opzettelijk reconquista om handelredenen',
        'Alle regio\'s veroverden tegen identieke snelheid',
        'Christelijke koninkrijken coördineerden nooit, waardoor verovering willekeurig verliep',
      ],
      0,
      'Castilië\'s grotere demografische middelen en aaneengesloten Islamitische grenzen maakten snellere reconquista mogelijk; Aragón\'s Middellandse-Zeeoriëntatie vertragde Iberische expansie.',
    ],
    [
      'Hoe beïnvloedde de Kroon van Aragón\'s Middellandse Zee-handelsnetwerken haar benadering van koloniale administratie?',
      [
        'Aragón\'s handelsoligarchieën eisten handelsposten boven territoriaal verovering, vertragend volledige Amerikaanse kolonisatie vergeleken met Castilië',
        'Aragón controleerde alle Spaanse koloniën uitsluitend',
        'Aragón verwierp handel en vermeed geheel Amerika',
        'Beide kronen volgden identieke koloniale strategieën onmiddellijk',
      ],
      0,
      'Aragón\'s koopmanklasse en Middellandse-Zeeoriëntatie duwden aanvankelijk naar handelspost-kolonialisme; Castilië\'s dominantie legde territoriale verovering als koloniaal model op.',
    ],
    [
      'Welke structurele betrekking bestond tussen de Spaanse Inquisitie en koninklijk fiscaal beleid?',
      [
        'Inquisitie-confiscaties van ketters\' bezit leverden Kroonopbrengsten terwijl religieuze orthodoxie via terreur werd gehandhaafd',
        'De Inquisitie opereerde onafhankelijk zonder koninklijke financiële betrokkenheid',
        'Inquisitie-opbrengsten gingen uitsluitend naar de Kerk zonder Kroon-voordeel',
        'De Inquisitie had geen confiscatiemachten',
      ],
      0,
      'De Kroon franchiseerde Inquisitie-vervolging; geconfisceerde goederen vloten naar koninklijke schatkisten, creërend perverse financiële stimulansen voor vervolging.',
    ],
    [
      'Hoe verschilden Habsburg-interpretatie van soevereiniteit van eerdere Reconquista-era-concepten van koninklijke autoriteit?',
      [
        'Habsburgen eisten absolute soevereiniteit van goddelijk recht over alle gebieden; eerdere koningen onderhandeelden met adel via fuero\'s',
        'Eerdere koningen waren absoluut; Habsburgen waren zwak en ondergeschikt aan adel',
        'Beiden gebruikten identieke vormen van koninklijke autoriteit',
        'Soevereiniteitsconcepten veranderden niet tussen perioden',
      ],
      0,
      'Habsburgen stelden gecentraliseerde goddelijk-rechtmonarchia in; Reconquista-era-kronen bleven gebonden door onderhandelde adelsprivileges (fuero\'s), creërend structurele verschillen.',
    ],
    [
      'Welke economische gevolgen volgden uit de 1609 Morisco-uitzetting voor Spanje\'s arbeidsverstrekking en fiscale basis?',
      [
        'Uitzetting van misschien 300.000 Moslims creëerde landbouwarbeidsschaarste en reduceerde Kroonbelastingopbrengsten aanzienlijk',
        'De uitzetting had geen economische impact',
        'Spanje\'s economie verbeterde onmiddellijk na uitzetting',
        'De uitgezette Morisco\'s keerden vrijwillig terug',
      ],
      0,
      'De Morisco-uitzetting putte de landbouwarbeid en landelijke belastingopbrengsten uit, wat bijdroeg aan Spanje\'s relatieve economische verval in de 17e eeuw.',
    ],
    [
      'Hoe beïnvloedde Amerikaanse schatinstroom Spanje\'s monetair beleid en Europese inflatietariefen?',
      [
        'Massale zilververstrekking veroorzaakte vraag-pull-inflatie in Europa en erodeerde de Spaanse concurrentiepositie, terwijl de prijzen in Spanje zelf sneller opliepen',
        'Amerikaans zilver had geen effect op Europese prijzen',
        'Zilver veroorzaakte deflatie in Europa',
        'Spanje was het enige land dat door prijswijzigingen werd beïnvloed',
      ],
      0,
      'De 16e-eeuwse prijsrevolutie volgde gedeeltelijk uit Nieuw-Wereld-zilver overstelping van Europese markten; Spanje leed het meest terwijl binnenlandse prijzen snelst stegen.',
    ],
    [
      'Welke rol speelde het Verdrag van Westfalen (1648) in herconfiguratie van Spaanse geopolitieke status?',
      [
        'Westfalen bevestigde Spaanse verval door Nederlandse onafhankelijkheid en Franse opkomst te erkennen, eindigend Spaanse Europese hegemonie',
        'Spanje verkreeg nieuw grondgebied via verdrag',
        'Westfalen had geen geopolitieke gevolgen',
        'Spanje werd Europese dominante macht na Westfalen',
      ],
      0,
      'Westfalen codificeerde Spaanse zwakte: Nederlandse onafhankelijkheid, Franse expansie en Zweedse opkomst eindigden Spaanse dominantie sinds Karel V.',
    ],
    [
      'Hoe beïnvloedde fiscale druk uit wereldwijd imperium-handhaving Spanje\'s vermogen investeren in binnenlandse fabrikage?',
      [
        'Militaire en koloniale uitgaven onttrokken kapitaal aan de Spaanse industrie, wat leidde tot importafhankelijkheid en relatieve deïndustrialisatie',
        'Spanje investeerde gelijk in fabrikage en militaire uitgaven',
        'Spanje concentreerde zich geheel op fabrikage en verwaarloosd militaire behoeften',
        'Spanje had onbeperkte hulpbronnen voor zowel fabrikage als oorlogvoering',
      ],
      0,
      'Imperium-kosten draineerden kapitaal van productieve investering; Spanje importeerde vervaardigde goederen terwijl economisch afhankelijk werd van koloniaal tribut.',
    ],
    [
      'Welke administratieve hervormingen legden de Bourbonische Successie-Oorlog-uitkomsten op Spaanse bestuurstructuren op?',
      [
        'Het Decree van Nueva Planta schafde fuero\'s van kroon-van-Aragón af en maakte regionale kronen ondergeschikt aan Castiliaanse administratieve modellen',
        'Regionale privileges werden na oorlog versterkt',
        'Geen administratieve veranderingen vonden plaats',
        'Spanje werd na oorlog meer gedecentraliseerd',
      ],
      0,
      'Filips V\'s Bourbonische hervormingen elimineerden Aragón-, Valencia- en Mallorca-fuero\'s, en legden zo een Castiliaans gecentraliseerde administratie op, wat de regionale autonomie verminderde.',
    ],
    [
      'Hoe betwistten de Schiereilandoorlog\'s guerrilla-tactieken hedendaagse militaire theorie en Europese strategische aannames?',
      [
        'Spaanse guerrilla-netwerken toonden dat populaire irreguliere troepen reguliere legers zonder conventionele overwinningen konden weerstaan, wat de Napoleontische doctrine omverwierp',
        'Guerrilla\'s waren militair onbetekenend en Europa negeerde hen',
        'Spanje gebruikte alleen conventionele militaire tactieken',
        'Guerrilla-oorlogvoering was sinds oudheidwijd standaard zonder nieuwe gevolgen',
      ],
      0,
      'Spaanse guerrilla\'s (1808–1814) toonden dat irreguliere troepen indringers door slijtage en logistieke verstoring konden uitputten, wat het militaire denken revolutioneerde.',
    ],
    [
      'Welke rol speelde de Cortes van Cádiz (1812) in opbouwen van constitutionele kaders die vervolgend Spaans liberalisme beïnvloedde?',
      [
        'De Cortes creëerde Spanje\'s eerste constitutionele document tijdens de Franse bezetting, en stelde liberale beginselen vast die de post-1820-conflicten vormden',
        'De Cortes had geen constitutionele betekenis',
        'Spanje ontwikkelde nooit constitutionele tradities voor 1975',
        'De Cortes schafde alle monarchie af en stelde een republiek in',
      ],
      0,
      'De Cádiz-Constitutie (1812) introduceerde parlementaire representatie en een beperkte monarchie, en werd een liberaal referentiepunt gedurende de 19e-eeuwse Spaanse politiek.',
    ],
  ],
  professor: [
    [
      'Hoe betwisten recente genetische en archeologische analyses eerdere aannames over genetische en culturele discontinuïteit tussen Visigotisch en Islamitische populaties?',
      [
        'DNA-bewijs suggereert significante Berber- en Arabische genetische inzet in plaats van vervanging; nederzettingspatronen en huishoudpraktijken tonen geleidelijke culturele synthese',
        'Genetica bewijst conclusief volledige bevolkingsvervanging zonder menging',
        'Archeologisch bewijs is irrelevant voor begrip van deze periode',
        'Recente wetenschap heeft niet Visigotisch-Islamitische overgangen onderzocht',
      ],
      0,
      'Recente archaeogenetische studies duiden op menging in plaats van vervanging; nederzettingsarcheologie openbaart continuïteit in huishoudpraktijken ondanks administratieve verandering.',
    ],
    [
      'Welke historiografische betekenis heeft het Muwalladun-concept voor de herziening van aannames over Al-Andalus\' religieuze en etnische categorisering?',
      [
        'Muwalladun (Gearabiseerde Christenen) bemoeilijken de binaire Moslim/Christelijke categorisering, en onthullen vloeibare religieuze grenzen en huwelijken over veronderstelde grenzen heen',
        'Muwalladun waren zuiver mythologisch zonder historische basis',
        'Religieuze grenzen waren absoluut en hermetisch verzegeld',
        'Alle populaties bekeerden instant zonder tussenliggende categorieën',
      ],
      0,
      'Muwalladun—Gearabiseerde Christenen die hun geloof handhaafden of zich strategisch bekeerden—openbaren vervaagde religieuze identiteiten en tonen aan dat sektarische categorieën de complexiteit van het geleefde leven verhullen.',
    ],
    [
      'Hoe betwisten recente analyses van Umayyadse administratieve apparaat aannames over institutionele samenhang tegen tribalisme?',
      [
        'Gedetailleerde administratieverslagen tonen geavanceerde bureaucratische structuren, geërfd van Byzantijnse modellen, wat narratieven over Bedoeïenen-chaos weerlegt',
        'Umayyadse administratie was zuiver stamachtig zonder formele structuren',
        'Byzantijnen hadden geen administratieve invloed op Umayyadden',
        'Al-Andalus ontwikkelde nooit administratieve systemen',
      ],
      0,
      'Umayyadse administratieverslagen onthullen continuïteit met de Byzantijnse diwans; deze geavanceerdheid weerlegt eerdere geleerdheid die het Islamitische bestuur als chaotisch of zuiver persoonlijk afschilderde.',
    ],
    [
      'Welke rol speelde het repoblación-concept bij de organisatie van de Castiliaanse territoriale expansie, en hoe hervormde het de arbeids- en bezitsverhoudingen?',
      [
        'Repoblación leidde populaties (via fuero-charters) naar veroverd grondgebied, wat nieuwe eigendomshiërarchieën creëerde en arbeidsrelaties verschoof van feodale naar loonarbeid-modellen',
        'Repoblación gebeurde nooit en populaties bleven sedentair',
        'Repoblación creëerde instant identieke feodale structuren overal',
        'Arbeidsrelaties veranderden nooit gedurende Reconquista',
      ],
      0,
      'Repoblación combineerde bevolkingsstimulansen (fuero-charters die privileges boden) met eigendomsherverdeling; het verzwakte geleidelijk feodale arbeidsbanden en creëerde loonafhankelijke populaties.',
    ],
    [
      'Hoe betwisten recente studies van taifa-economieën aannames over Al-Andalus\' verval als zuiver militair of politiek fenomeen?',
      [
        'Economische analyses onthullen dat fragmentering lange-afstandshandelsnetwerken en fiscale inning destabiliseerde, ondanks lokale marktcontinuïteit',
        'Economisch verval was onmiddellijk en universeel over alle taifa\'s',
        'Taifa\'s hadden geen economische impact op Middellandse Zeehandel',
        'Economieën waren identiek voor en na fragmentering',
      ],
      0,
      'Taifa-fragmentering verstoorde lange-afstandshandelsnetwerken en de belastinginningsefficiëntie, in plaats van een totale ineenstorting te veroorzaken; lokale markten bleven bestaan, maar de macro-economische complexiteit nam af.',
    ],
    [
      'Welk historisch debat omringt omvang van gedwongen versus vrijwillige bekering onder Islamitische populaties tijdens Reconquista?',
      [
        'Revisionistische geleerdheid benadrukt aanzienlijke vrijwillige bekering gedreven door sociale mobiliteit en economische stimulansen, niet uitsluitend geweld',
        'Alle bekering waren geheel vrijwillig zonder dwang',
        'Alle bekering waren geheel gedwongen zonder vrijwillige participatie',
        'Geen bekering gebeurde tijdens Reconquista',
      ],
      0,
      'Recente geleerdheid identificeert gemengde mechanismen: juridische beperkingen stimuleerden bekering; de jizya-belasting creëerde economische druk; toch bekeerden sommigen zich ook met het oog op sociale stijging.',
    ],
    [
      'Hoe verduidelijken analyses van encomienda\'s arbeidsoverschot-mechanismen zijn onderscheiding van slavernij in Spaanse juridische theorie?',
      [
        'Encomienda verleende alleen het vruchtgebruik (niet het eigendom) van arbeid, en behield juridisch de status van onderdaan, terwijl onbeperkte extractie in de praktijk mogelijk was',
        'Encomienda was identiek aan slavernij in elk opzicht',
        'Encomienda verleende volledige juridische slavernij zonder ambiguïteit',
        'Arbeidsextractie-mechanismen ontwikkelden nooit in koloniën',
      ],
      0,
      'Encomienda behield subjecten als Kroon-vazallen (geen eigendom) terwijl encomenderos hun arbeid controleerden, creërend juridische fictie verduisterend de facto slavernij.',
    ],
    [
      'Welke historiografische herzieningen hebben recente studies voortgebracht betreffende omvang van Converso-netwerken\'s economische invloed in Habsburg Spanje?',
      [
        'DNA- en archiefonderzoek onthullen uitgebreide Converso-koopman- en intellectuele netwerken ondanks Inquisitie-vervolging, en betwisten zo aannames over hun marginalisatie',
        'Converso\'s hadden nul economische of intellectuele invloed',
        'Inquisitie-vervolging had geen werkelijke effecten op Converso-activiteit',
        'Alle Spaanse kooplui en intellectuelen waren uitsluitend Oud-Christelijk',
      ],
      0,
      'Recente geleerdheid documenteert diepgaande Converso-penetratie van handel, medicijn en recht ondanks vervolging; zij bleven economisch cruciaal onder voortdurende argwaan.',
    ],
    [
      'Hoe functioneerde de retorische construct van limpieza de sangre (bloedzuiverheid) als economisch uitsluitingsmechanisme onderscheiden van religieuze orthodoxie?',
      [
        'Limpieza-ideologie sloot kooplui en professionals met Joodse of Moslimancestrie uit van gildepositie en Kroonkantoor, en consolideerde zo Oud-Christelijke economische monopolies',
        'Limpieza had geen economische gevolgen en was zuiver religieus',
        'Limpieza profiteerde alle sociale klassen gelijk',
        'Bloedzuiverheidsweizen existeerden nooit in Spaans recht',
      ],
      0,
      'Limpieza-decreten functioneerden als professionele poortbewaking: Converso\'s uitsluiting van gildes, universiteiten en kantoor handhaafden Oud-Christelijke rijkdoms- en statusmonopolies.',
    ],
    [
      'Welke mechanismen van fiscale centralisatie gebruikte Karel V om regionale kronen\'s financiële autonomie te onderwerpen zonder formeel fuero\'s af te schaffen?',
      [
        'De Kroon controleerde strategische monopolies (zout, kwik, tabak) en eiste vaste servicios, terwijl beperkte lokale belastingautonomie toegestaan bleef, wat de facto fiscale dominantie opleverde',
        'Regionale kronen behielden volledige financiële onafhankelijkheid',
        'Karel V schafde onmiddellijk alle regionale financiële autoriteit af',
        'Fiscale mechanismen veranderden nooit tijdens Karel V\'s heerschappij',
      ],
      0,
      'Karel V monopoliseerde strategische goederen en legde vaste \'service\'-betalingen op; regio\'s belastten lokaal, maar dat gebeurde binnen beperkingen, waardoor hij dominantie bereikte zonder formele afschaffing.',
    ],
    [
      'Hoe verklaren recente analyses van Amerikaanse schatenstromingen\' snelheid en distributie Spanje\'s paradoxale armoede ondanks zilveroervloed?',
      [
        'Snelle schatcirculatie voedde vraag-pull-inflatie en muntverslechtering in plaats van productieve investering; buitenlandse kooplui capteerden monetair overschot via importvraag',
        'Spaanse schatorervloed maakte Spanje uniform welvarend',
        'Schat had geen monetaire effecten',
        'Buitenlandse kooplui participeerden nooit in Spaanse handel',
      ],
      0,
      'De Spaanse inflatie steeg boven het Europese gemiddelde uit, terwijl zilver de markt overspoelde; hoge binnenlandse prijzen verminderden het concurrentievermogen van Spaanse exportgoederen, wat buitenlandse handelaren verrijkte.',
    ],
    [
      'Welk historiografisch debat concentreert zich op de vraag of Filips II\'s militaire uitgaven een rationele staatsstrategie vertegenwoordigden, of juist ideologische overdaad?',
      [
        'Revisionisten stellen dat religieuze ideologie en dynastieke eer een rationele kosten-batenanalyse verdrongen, wat leidde tot onhoudbare militaire uitgaven ten opzichte van de inkomstenbasis',
        'Militaire uitgaven waren zuiver rationeel zonder ideologische component',
        'Filips II had onbeperkte hulpbronnen voor elk militair avontuur',
        'Militaire uitgaven beïnvloedden nooit Spaanse financiën',
      ],
      0,
      'Geleerden debatteren of Filips II\'s oorlogen tegen Protestantisme en Ottomanen werkelijke strategische belangen of ideologische imperatieve groter dan rationeel ROI weerspiegelden.',
    ],
    [
      'Hoe hervormd het Decree van Nueva Planta\'s afschaffing van kroon-van-Aragón-fuero\'s de relatie tussen lokale instellingen en gecentraliseerde bureaucratie?',
      [
        'Het decreet maakte regionale raden ondergeschikt aan koninklijke corregidores en verwijderde fiscale autonomie, waarmee Aragón werd geïntegreerd in de Castiliaanse administratieve hiërarchie terwijl de monarchie formeel behouden bleef',
        'Aragón behield volledige institutionele onafhankelijkheid na decreet',
        'Het decreet creëerde onmiddellijk uniforme Spaans bestuur',
        'Geen administratieve reorganisatie gebeurde na Successie-oorlog',
      ],
      0,
      'Nueva Planta loste het gezag van de kroon-van-Aragón-instellingen op, voerde Castiliaanse corregidores in en centraliseerde de belastinginning, terwijl de regionale kronen nominaal gehandhaafd bleven.',
    ],
    [
      'Welke rol speelde Napoleonse bezettings-verbreking van Amerikaanse handelsmonopolies in Spanje\'s na-oorlogse economische verval?',
      [
        'De Franse blokkade verbrak Spanje\'s controle over de Amerikaanse handel; ook na 1814 verhinderden Amerikaanse onafhankelijkheidsbewegingen het herstel van het monopolie, wat de traditionele inkomstenbasis vernietigde',
        'Amerikaanse handel bleef onveranderd gedurende en na Schiereilandoorlog',
        'Spanje\'s Amerikaans monopolie was irrelevant voor algehele welvaart',
        'Schiereilandoorlog had geen economische gevolgen',
      ],
      0,
      'De Napoleontische Oorlogen verbrijzelden Spanje\'s Amerikaanse handelsmonopoliestelsel; na 1814 elimineerde de Latijns-Amerikaanse onafhankelijkheid permanent de monopoliewinsten die het Spaanse verval tot dan toe hadden verzacht.',
    ],
    [
      'Hoe herzien recente constitutionele geleerdheid inzicht in Cádiz Cortes\' institutionele innovaties voorbij liberale ideologie?',
      [
        'Cádiz pionierde met electorale mechanismen (vrouwen uitsluitend, maar wel blind voor eigendom), provinciale representatie en machtsscheiding, wat het constitutionele ontwerp buiten Spanje beïnvloedde',
        'Cádiz creëerde niets institutioneel innovatief',
        'Cádiz was zuiver ideologisch zonder institutionele effecten',
        'Electorale mechanismen ontwikkelden nooit voor 20e eeuw',
      ],
      0,
      'Cádiz-Constitutie stelde parlementaire commissies, min-of-meer provinciale representatie en justitiële scheiding vast, voorgaand latere Europese modellen.',
    ],
  ],
};
